import _ from 'lodash';

class ComplementoComercioExteriorRequestInputTransformer {
  getName() {
    return 'ComercioExterior';
  }

  make(input) {
    const { Complemento = {} } = input;

    if (!Complemento || !Complemento.ComercioExterior) {
      return input;
    }

    let comercioExterior = { ...Complemento.ComercioExterior };

    comercioExterior = this._clearInput(comercioExterior);

    let { Emisor = {}, Receptor = {}, Destinatario = [], Propietario = [], Mercancias = {} } = comercioExterior;
    let { Mercancia = [] } = Mercancias;

    Emisor = this._clearInput(Emisor);
    let EmisorDomicilio = this._clearInput(Emisor.Domicilio);

    Emisor = {
      ...Emisor,
      Domicilio: {
        ...EmisorDomicilio,
      },
    };

    Receptor = this._clearInput(Receptor);
    let ReceptorDomicilio = this._clearInput(Receptor.Domicilio);

    Receptor = {
      ...Receptor,
      Domicilio: {
        ...ReceptorDomicilio,
      },
    };

    if (!!Destinatario) {
      Destinatario = Destinatario.map((item) => {
        const { Domicilio = [] } = item;

        item.Domicilio = Domicilio.map((Domicilio) => {
          return this._clearInput(Domicilio);
        });

        return this._clearInput(item);
      });
    }

    if (!!Propietario) {
      Propietario = Propietario.map((item) => {
        return this._clearInput(item);
      });
    }

    Mercancia = Mercancia.map((item) => {
      const { DescripcionesEspecificas = [] } = item;

      item.DescripcionesEspecificas = DescripcionesEspecificas.map((item) => {
        return this._clearInput(item);
      });

      return this._clearInput(item);
    });

    comercioExterior = {
      ...comercioExterior,
      Version: '2.0',
      TipoOperacion: '2',
      ClaveDePedimento: 'A1',
      Subdivision: '0',
      Emisor: {
        ...Emisor,
      },
      Receptor: {
        ...Receptor,
      },
      Destinatario: [...Destinatario],
      Propietario: [...Propietario],
      Mercancias: {
        Mercancia: [...Mercancia],
      },
    };

    input.Complemento = {
      ...input.Complemento,
      ComercioExterior: comercioExterior,
    };

    return input;
  }

  _clearInput(input) {
    return _.pickBy(input, _.identity);
  }
}

export default ComplementoComercioExteriorRequestInputTransformer;
